var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canDisplayImage)?_c('b-img',{attrs:{"src":_vm.displaySrc}}):_c('b-col',{staticClass:"px-0"},[_c('b-skeleton-img')],1)}
var staticRenderFns = []

export { render, staticRenderFns }